import React from 'react';
import Login from "../Login";
import SLogo from '../../assets/images/SLogo.png';
import {makeStyles} from "@material-ui/core/styles";
import foto_landing from "../../assets/images/Foto_Landing.jpg";
import useWindowDimensions from "../../useWindowDimensions";

const useStyles = makeStyles(theme => ({
    root: {
        height: "100%",
        width: "100%",
        position: "absolute",
        left: "0",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundImage: `url(${foto_landing})`,
        backgroundPosition: 'right top',
        backgroundSize: 'cover',
    },
    superiorRow: {
        display:"flex",
        flexDirection:"row",
        width:"100%",
        justifyContent:"start",
        height:"250px"
    },
    middleRow: {
        display:"flex",
        flexDirection:"column",
        justifyContent:"space-evenly",
        alignItems:"center",
        width:"100%",
        height:"280px"
    },
    imgCircle: {
        width:"400px",
        clipPath: "circle(70% at 35% 4%)",
        backgroundColor:"#004285"
    },
    imgSancor: {
        height:"120px",
        width:"auto",
        position:"absolute",
        top:"32px",
        left:"32px"
    },
    bienvenidoText: {
        fontFamily: "EncodeSansBold",
        fontSize:"48px"
    },
    otherText: {
        fontFamily: "EncodeSansLight",
        fontSize:"48px"
    },
    pinkRectangle: {
        color: "white",
        backgroundColor: "#bb0d66",
        position: "relative",
        clipPath: "polygon(0 0, 600px 0, 600px 500px, 0 300px)",
    },
    blueRectangle: {
        color: "white",
        backgroundColor: "#004285",
        position: "relative",
        height: "100%",
        clipPath: "polygon(0 0, 300px 0, 300px 80px, 0 80px);",
    },
    spacing: {
        padding: "0 16px",
    },
}))

const LandingAdviser = () => {
    const classes = useStyles();
    return (
        <React.Fragment>
            <div className={classes.root}>
                <div className={classes.superiorRow}>
                    <div className={classes.imgCircle}>
                        <img src={SLogo} className={classes.imgSancor}/>
                    </div>
                </div>
                <div className={classes.middleRow}>
                    <div>
                        <p className={`${classes.bienvenidoText} ${classes.blueRectangle} ${classes.spacing}`}>
                            Bienvenido
                        </p>
                    </div>
                    <div>
                        <p className={`${classes.otherText} ${classes.pinkRectangle} ${classes.spacing}`}>
                            a tu gestor de afinidades
                        </p>
                    </div>
                    <Login/>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LandingAdviser;


